import { numberToPrettyString } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';

import { IDeveloperInfo } from '../../../../api/developers';
import { IBreadcrumb } from '../../../../offer';

const style = require('./index.css');

export interface IHeaderDeveloperProps {
  breadcrumbs: IBreadcrumb[];
  developerInfo: IDeveloperInfo;
}

export class HeaderDeveloper extends React.Component<IHeaderDeveloperProps> {
  public render() {
    const { developerInfo } = this.props;

    return (
      <div className={style.container}>
        <div itemScope className={style.wrapper} itemType="http://schema.org/BreadcrumbList">
          {this.props.breadcrumbs.length > 0 && (
            <div
              itemProp="itemListElement"
              itemType="http://schema.org/ListItem"
              itemScope
              className={style['breadcrumbs']}
            >
              {this.props.breadcrumbs.map((breadcrumb, index, arr) => {
                return (
                  <a
                    key={index}
                    href={breadcrumb.url || undefined}
                    title={breadcrumb.title || ''}
                    itemProp="url"
                    className={style['breadcrumbs-link']}
                  >
                    <span itemProp="name">{breadcrumb.title}</span>
                    {index < arr.length - 1 ? <div className={style['breadcrumbs-delimiter']} /> : null}
                  </a>
                );
              })}
            </div>
          )}
          <h1 className={style['title']}>
            Купить квартиру от застройщика{' '}
            <a href={developerInfo.url} target="_blank">
              &laquo;{developerInfo.name}&raquo;
            </a>
          </h1>
          <div className={style['content']}>
            <div className={style['content-logotype']}>
              <a href={developerInfo.url} target="_blank">
                <img src={developerInfo.logoUrl} alt={developerInfo.name} />
              </a>
            </div>
            <div className={style['content-main']}>
              <div className={style['content-info']}>
                &laquo;{developerInfo.name}&raquo;{developerInfo.since && ` на ЦИАН с ${developerInfo.since} г.`}
              </div>
              {developerInfo.newobjectsStats.length > 0 && (
                <div className={style['content-projects']}>
                  <div className={style['content-projectsLabel']}>Проектов в базе ЦИАН:</div>
                  <div className={style['content-projectsData']}>
                    <ul className={style['content-projectsList']}>
                      {developerInfo.newobjectsStats.map((stat, index) => (
                        <li key={`stat-${index}`}>
                          <a href={stat.url} target="_blank">
                            {stat.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              <div className={style['content-description']}>
                {/* tslint:disable-next-line:max-line-length */}
                <p>
                  Все новостройки от застройщика <a href={developerInfo.newobjectsUrl}>{developerInfo.name}</a>:
                  описание объектов, фотографии, планировка, цены.
                  {developerInfo.flatsStat && developerInfo.flatsStat.flats.length > 0 && (
                    <span>
                      {/* tslint:disable-next-line:max-line-length */}В базе ЦИАН найдено{' '}
                      <a href={developerInfo.flatsStat.url}>
                        {developerInfo.flatsStat.total}{' '}
                        {plural(developerInfo.flatsStat.total, ['квартира', 'квартиры', 'квартир'])}
                      </a>{' '}
                      от застройщика <a href={developerInfo.newobjectsUrl}>{developerInfo.name}</a>:{' '}
                      {this.renderFlatsList()}.
                      {developerInfo.flatsStat.minPrice &&
                        developerInfo.flatsStat.maxPrice &&
                        ` Минимальная цена квартиры - ${numberToPrettyString(
                          developerInfo.flatsStat.minPrice,
                        )} ${plural(developerInfo.flatsStat.minPrice, [
                          'рубль',
                          'рубля',
                          'рублей',
                        ])}, максимальная - ${numberToPrettyString(
                          developerInfo.flatsStat.maxPrice,
                        )} ${plural(developerInfo.flatsStat.maxPrice, ['рубль', 'рубля', 'рублей'])}.`}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private renderFlatsList() {
    const flats = this.props.developerInfo.flatsStat.flats;
    if (flats.length === 0) {
      return null;
    }

    // tslint:disable-next-line:no-any
    const flatsList: (React.ReactElement<any> | string)[] = [];

    const oneRoom = flats.find(flat => flat.roomCountType === 'oneRoom');
    if (oneRoom) {
      flatsList.push(
        <a key="flat-1" href={oneRoom.url}>
          однокомнатных - {oneRoom.count}
        </a>,
      );
    }

    const twoRooms = flats.find(flat => flat.roomCountType === 'twoRoom');
    if (twoRooms) {
      flatsList.push(
        <a key="flat-2" href={twoRooms.url}>
          двухкомнатных - {twoRooms.count}
        </a>,
      );
    }

    const threeRooms = flats.find(flat => flat.roomCountType === 'threeRoom');
    if (threeRooms) {
      flatsList.push(
        <a key="flat-3" href={threeRooms.url}>
          трехкомнатных - {threeRooms.count}
        </a>,
      );
    }

    const fourRooms = flats.find(flat => flat.roomCountType === 'fourRoom');
    if (fourRooms) {
      flatsList.push(
        <a key="flat-4" href={fourRooms.url}>
          четырехкомнатных - {fourRooms.count}
        </a>,
      );
    }

    const fiveRooms = flats.find(flat => flat.roomCountType === 'fiveRoom');
    if (fiveRooms) {
      flatsList.push(
        <a key="flat-5" href={fiveRooms.url}>
          пятикомнатных - {fiveRooms.count}
        </a>,
      );
    }

    const multiRooms = flats.find(flat => flat.roomCountType === 'multiRoom');
    if (multiRooms) {
      flatsList.push(
        <a key="flat-6" href={multiRooms.url}>
          многокомнатных - {multiRooms.count}
        </a>,
      );
    }

    const studio = flats.find(flat => flat.roomCountType === 'studio');
    if (studio) {
      flatsList.push(
        <a key="flat-7" href={studio.url}>
          студий - {studio.count}
        </a>,
      );
    }

    const openPlan = flats.find(flat => flat.roomCountType === 'openPlan');
    if (openPlan) {
      flatsList.push(
        <a key="flat-8" href={openPlan.url}>
          свободной планировки - {openPlan.count}
        </a>,
      );
    }

    return flatsList.slice(1).reduce(
      (previousValue, currentValue, index) => {
        return previousValue.concat([', ', currentValue]);
      },
      [flatsList[0]],
    );
  }
}
